export default "__VITE_ASSET__O010HA3s__"